// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1619923465017
      var cssReload = require("/mnt/main/Projects/Personal/Typescript/backup/rect-annotate/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  